import script from "./TextInputComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TextInputComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__